import * as React from "react"
import Typography from "@mui/material/Typography"
import MuiBreadcrumbs from "@mui/material/Breadcrumbs"
import Link from "src/shared/components/Link"

import { styled } from "@mui/material"
import { BreadcrumbItem } from "src/shared/utils/breadcrums"

interface BreadcrumbsProps {
  items: BreadcrumbItem[]
}

const Breadcrumbs: React.FC<BreadcrumbsProps> = ({ items }) => {
  const mappedItems = React.useMemo(
    () => items?.map((val) => ({ label: val.label?.replace("-", " "), path: val.path })),
    [items]
  )
  return (
    <MuiBreadcrumbs aria-label="breadcrumb">
      {mappedItems.map((item, index) =>
        index < items.length - 1 && item.path ? (
          <LinkStyled key={item.path} style={{ textTransform: "capitalize" }} color="inherit" to={item?.path}>
            {item.label}
          </LinkStyled>
        ) : (
          <Typography key={index} textTransform={"capitalize"} color="text.primary">
            {item.label}
          </Typography>
        )
      )}
    </MuiBreadcrumbs>
  )
}

const LinkStyled = styled(Link)({
  fontWeight: 400,
  "&:hover": {
    textDecoration: "underline"
  }
})
export default Breadcrumbs
